import { useEffect } from 'react';

export function useKeyboardPadding() {
  useEffect(() => {
    if (!window.visualViewport) return;

    const handleResize = () => {
      const viewportHeight = window.visualViewport.height;
      const windowHeight = window.innerHeight;

      const keyboardHeight = Math.max(0, windowHeight - viewportHeight);

      document.documentElement.style.setProperty(
        '--keyboard-padding',
        `${keyboardHeight}px`
      );
    };

    window.visualViewport.addEventListener('resize', handleResize);
    window.visualViewport.addEventListener('scroll', handleResize);

    handleResize();

    return () => {
      window.visualViewport.removeEventListener('resize', handleResize);
      window.visualViewport.removeEventListener('scroll', handleResize);
    };
  }, []);
}